// Partner/affiliate referral attribution for the free funnel.
// A VIP partner shares /getleads?a=CODE (or ?ref=CODE). We persist the code for
// the session so it rides every lead-capture call (capture / answers / scan
// claim) and lands on the lead as `affiliate_code` — which carries through to the
// paid kickoff session automatically, so the partner gets credited even for a
// lead that converts days later.
const KEY = "slammed_aff";

export function getAffiliateCode() {
  try {
    const sp = new URLSearchParams(window.location.search);
    const fromUrl = (sp.get("a") || sp.get("ref") || "").trim().slice(0, 60);
    if (fromUrl) {
      sessionStorage.setItem(KEY, fromUrl);
      return fromUrl;
    }
    return (sessionStorage.getItem(KEY) || "").trim();
  } catch {
    return "";
  }
}
